import React from "react";
import Layout from "../layout";
import Faq from "../home/faq";
import JoinUs from "../home/joinus";
import FollowUs from "../home/followus";

const About_Us = () => {
  return (
    <>
      <div className="section">
        <div className="div-block-74">
          <h1 className="header-big mt-110">about us</h1>
        </div>
      </div>

      <div className="section dark-bg">
        <div className="about-us-content">
          <div className="about-us-pic">
            <img
              src="./assets/WEBSITE IMAGES/ARJUN CUP TAEKWONDO CHAMPIONSHIP/09.png"
              loading="lazy"
              sizes="(max-width: 479px) 94vw, 54vw"
              alt="About Us"
              className="about-us-pic1"
            />
          </div>
          <div className="about-us-description">
            <p className="paragraph white-text">
              <b>MRG Multisports Club</b>, based in Jaipur, Rajasthan, is
              dedicated to promoting sports and fostering athletic talent. With
              a mission to enhance the sports culture in the region, the club
              organizes a wide range of events across different disciplines.
            </p>
            <p className="heading-accent white-text mt-20">
              MRG Multisports Club brings together athletes, enthusiasts, and
              communities to celebrate the spirit of sports.
            </p>
          </div>
        </div>
      </div>

      <div className="section">
        <div className="about-us-3screen">
          <div className="about-us-pic-3">
            <img
              src="./assets/images/sonika.jpeg"
              loading="lazy"
              sizes="(max-width: 479px) 100vw, 30vw"
              alt="Director"
              className="about-us-pic3"
            />
            <div className="link-4ocean-aboutus">
              <a
                href="http://mrgmultisportsclub.com"
                target="_blank"
                rel="noopener noreferrer"
                className="link_small link_philosophy about-us-mission-link"
              >
                <span className="text-span-2 link-brown">
                  mrgmultisportsclub.com
                </span>
              </a>
            </div>
          </div>
          <div className="about-us-description-mission">
            <p className="heading-accent mission-aboutus-header">
              Director's Message
            </p>
            <p className="paragraph">
              Founded in 2019, MRG Multisports Club is a premier professional
              multi-sport organization based in Jaipur, Rajasthan. Initially
              established as a cricket-focused club, it has grown into a hub for
              diverse sports activities in the city.
            </p>
            <p className="paragraph">
              MRG Multisports Club prides itself on offering high-quality
              training through expert trainers, top-notch equipment, and
              world-class facilities.
            </p>
            <p className="paragraph">
              Over the last four years, MRG has hosted numerous cricket leagues
              and open championships, making it a recognized name in Rajasthan's
              sports community.
            </p>
            <a href="#" className="button">
              MRG Multisports Club is more than just a sports organization—it's
              a community that inspires excellence.
            </a>
          </div>
        </div>
      </div>

      <Faq />
      <JoinUs />
      <FollowUs />
    </>
  );
};

export default About_Us;
